import { render } from "./StoreNavigator.vue?vue&type=template&id=d8e96c7e&scoped=true"
import script from "./StoreNavigator.vue?vue&type=script&lang=js"
export * from "./StoreNavigator.vue?vue&type=script&lang=js"

import "./StoreNavigator.vue?vue&type=style&index=0&id=d8e96c7e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d8e96c7e"

export default script